// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.syncs-container {
  margin-left: 36px;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
.syncs-container h3 {
  text-align: left;
  font-size: 32px;
  margin-bottom: 10px;
  cursor: pointer;
}
.syncs-container h3 small {
  font-size: 20px;
  padding-left: 10px;
}
.syncs-container .schedule-container {
  flex-direction: row;
  align-items: center;
  margin-bottom: 0;
  display: flex !important;
}
.syncs-container .schedule-container .button-less-padding {
  padding: 0 10px;
}
.syncs-container .schedule-container .shop-ids-input {
  flex: 1 1;
  padding-right: 10px;
}
.syncs-container .schedule-container .shop-ids-input input {
  text-align: right;
}

.admin-view-class {
  display: flex;
  align-items: center;
}

.invoice-table-controls {
  padding: 0 5px;
  height: 80%;
}
.invoice-table-controls span {
  display: unset !important;
  font-size: small;
  padding: 0 5px 0 0 !important;
}

.manual-invoice-update__checkboxes {
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: space-between;
  margin: 20px 30px 10px;
}

.left-buttons {
  display: flex;
  gap: 10px;
}

.header-buttons {
  display: flex;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/MarketplaceControl/components/ControlSyncs.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EAWA,aAAA;EACA,sBAAA;EACA,iBAAA;AATF;AAHE;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAKJ;AAJI;EACE,eAAA;EACA,kBAAA;AAMN;AAAE;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;AAEJ;AADI;EACE,eAAA;AAGN;AADI;EACE,SAAA;EACA,mBAAA;AAGN;AAFM;EACE,iBAAA;AAIR;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AAAA;EACE,cAAA;EACA,WAAA;AAGF;AAFE;EACE,yBAAA;EACA,gBAAA;EACA,6BAAA;AAIJ;;AADA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;EACA,sBAAA;AAIF;;AAFA;EACE,aAAA;EACA,SAAA;AAKF;;AAFA;EACE,aAAA;EACA,SAAA;AAKF","sourcesContent":[".syncs-container {\n  margin-left: 36px;\n  h3 {\n    text-align: left;\n    font-size: 32px;\n    margin-bottom: 10px;\n    cursor: pointer;\n    small {\n      font-size: 20px;\n      padding-left: 10px;\n    }\n  }\n  display: flex;\n  flex-direction: column;\n  padding-top: 10px;\n  .schedule-container {\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 0;\n    display: flex !important;\n    .button-less-padding {\n      padding: 0 10px;\n    }\n    .shop-ids-input {\n      flex: 1;\n      padding-right: 10px;\n      input {\n        text-align: right;\n      }\n    }\n  }\n}\n.admin-view-class {\n  display: flex;\n  align-items: center;\n}\n.invoice-table-controls {\n  padding: 0 5px;\n  height: 80%;\n  span {\n    display: unset !important;\n    font-size: small;\n    padding: 0 5px 0 0 !important;\n  }\n}\n.manual-invoice-update__checkboxes {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  justify-content: space-between;\n  margin: 20px 30px 10px;\n}\n.left-buttons{\n  display: flex;\n  gap: 10px;\n}\n\n.header-buttons {\n  display: flex;\n  gap:20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
